import React, { useReducer, useState } from "react";
import ReactDOM from "react-dom";
import "./main.less";
import { Icon, Tooltip } from "@kdcloudjs/kdesign";
import "@kdcloudjs/kdesign/dist/kdesign.css";
import Grid from "./components/Grid/Grid";
import { getReactComponent } from "../../../../../util/reactComponent";
import { mockData } from "./mock";
/**
 * 在setHtml中声明Root类，使用ReactDOM.render将其渲染在model.dom中
 * 在Root类的componentDidMount里，声明一个订阅，用于接收后端更新发过来的消息，从而去更新组件
 * 在update里，发布一个消息，当后端插件给自定义控件传递新数据时，就能将消息发布给Root
 * 在Root类的componentWillUnmount里，取消订阅
 * 在destoryed里，使用ReactDOM.unmountComponentAtNode卸载Root
 * 注意loadFile中index.css的引入路径，因为webpack打包后将其放在了css文件夹里，所以路径是./css/index.css
 */
(function (KDApi) {
  var setHtml = function (model, primaryProps, { I18N }) {
    KDApi.loadFile("./css/index.css", model, () => {
      const Root = (props) => {
        const [data, setData] = useState(props.customProps?.data?.data);
        const {
          distributionRatio,
          gridData,
          xAxisInfo,
          yAxisInfo,
          personInfo,
        } = data;
        return (
          <div className={"talent-single-result-container"}>
            {data ? (
              <div className="single-result-main">
                <div className="main-content">
                  <Icon
                    className="up-icon-wrapper"
                    type="arrow-up-solid"
                    style={{ fontSize: "20px" }}
                  />
                  <Icon
                    className="right-icon-wrapper"
                    type="arrow-right-solid"
                    style={{ fontSize: "20px" }}
                  />
                  {yAxisInfo.name && (
                    <div className="y-title">{yAxisInfo.name}</div>
                  )}
                  {xAxisInfo.name && (
                    <div className="x-title">{xAxisInfo.name}</div>
                  )}
                  <Grid gridData={gridData} personInfo={personInfo} />
                  {["percent", "score"].includes(xAxisInfo.valueType.type) ||
                  ["percent", "score"].includes(yAxisInfo.valueType.type) ? (
                    <div className="x-y-zero">
                      0<Icon type={"arrow-up-solid"}></Icon>
                    </div>
                  ) : null}
                  <div className="yAxis-wrapper">
                    <div
                      className={"yAxis-list"}
                      style={{
                        gridTemplateRows: `repeat(${yAxisInfo.divideScale.values.length}, 1fr)`,
                      }}
                    >
                      {yAxisInfo.divideScale.values
                        .reduce((acc, num) => [num, ...acc], [])
                        .map((item, index) => (
                          <div key={index}>
                            <div
                              style={{
                                bottom:
                                  yAxisInfo.valueType.type === "grade"
                                    ? "50%"
                                    : index !== 0
                                    ? "calc(100% + 10px)"
                                    : "100%",
                                paddingRight:
                                  yAxisInfo.valueType.type === "grade"
                                    ? "8px"
                                    : "12px",
                              }}
                            >
                              {item ? (
                                <Tooltip placement="topRight" tip={item}>
                                  <div>{item}</div>
                                </Tooltip>
                              ) : (
                                ""
                              )}
                              {yAxisInfo.valueType.type == "grade" ||
                              !item ? null : (
                                <Icon type={"arrow-right-solid"}></Icon>
                              )}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                  <div className="xAxis-wrapper">
                    <div
                      className={"xAxis-list"}
                      style={{
                        gridTemplateColumns: `repeat(${xAxisInfo.divideScale.values.length}, 1fr)`,
                      }}
                    >
                      {xAxisInfo.divideScale.values.map((item, index) => (
                        <div key={index}>
                          <div
                            style={{
                              left:
                                xAxisInfo.valueType.type === "grade"
                                  ? "50%"
                                  : index !==
                                    xAxisInfo.divideScale.values.length - 1
                                  ? "calc(100% + 10px)"
                                  : "100%",
                            }}
                          >
                            <Tooltip tip={item} placement="top">
                              <div>{item}</div>
                            </Tooltip>
                            {xAxisInfo.valueType.type === "grade" ||
                            !item ? null : (
                              <Icon type={"arrow-up-solid"}></Icon>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        );
      };
      ReactDOM.render(
        <Root model={model} customProps={primaryProps} I18N={I18N} />,
        model.dom
      );
    });
  };

  const ReactComponent = getReactComponent(setHtml);
  // 注册自定义组件
  KDApi.register("talentSingleResult", ReactComponent);
})(window.KDApi);
